// extracted by mini-css-extract-plugin
module.exports = {"recentArticles":"_tEzy4K","sectionTitle":"_escjqM"};